import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { LocaleSelector } from "@redotech/redo-i18n/locale-selector";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { updateUserLocale } from "@redotech/redo-merchant-app-common/client/user";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { localizationEnabled } from "@redotech/redo-team-common/localization/settings";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useContext } from "react";
import * as css from "./merchant-locale-selector.module.css";

export const MerchantLocaleSelector = memo(function MerchantLocaleSelector() {
  const team = useContext(TeamContext);
  const user = useRequiredContext(UserContext);
  const client = useRequiredContext(RedoMerchantClientContext);
  const handleLocaleChange = useHandler((locale: string) => {
    void updateUserLocale(client, { userId: user._id, locale });
  });

  if (!localizationEnabled(team?.settings.localization)) {
    return null;
  }

  return (
    <Flex align="center" className={css.localeSelector}>
      <LocaleSelector onLocaleChange={handleLocaleChange} />
    </Flex>
  );
});
